import { Component } from 'react';
import firebase from '../tools/firebase';
import { withRouter } from 'react-router';
import { Container, Col, Row, Tabs, Tab, Card } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import style from '../style/truckPage_ui.module.css';

class TruckPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			truckId: '',
			truckInfo: null,
			truckHeroImgURL: '',
			comments: [],
			socialMedia: [],
			facebook: null,
			instagram: null,
			twitter: null,
			youtube: null,
			desserts: [],
			extras: [],
			entrees: [],
			drinks: [],
			isLoading: true,
			error: null,
		};
	}

	componentDidMount() {
		const id = this.props.match.params.truckId;
		this.setState({ truckId: id });

		const db = firebase.firestore();

		db.collection('trucks').doc(id).get()
			.then((doc) => {
				if (!doc.exists) {
					this.setState({ isLoading: false, error: 'Truck not found.' });
					return;
				}
				const truckData = doc.data();
				const social = truckData.socialmedia || [];
				this.setState({
					truckInfo: truckData,
					truckHeroImgURL: truckData.image || '',
					socialMedia: social,
					facebook:  social.find(a => a.key === 'facebook')  || null,
					instagram: social.find(a => a.key === 'instagram') || null,
					twitter:   social.find(a => a.key === 'twitter')   || null,
					youtube:   social.find(a => a.key === 'youtube')   || null,
					isLoading: false,
				});
			})
			.catch(() => this.setState({ isLoading: false, error: 'Could not load truck data.' }));

		db.collection('comments').where('truckID', '==', id).get()
			.then((snap) => {
				const commentArray = [];
				snap.forEach(doc => commentArray.push(doc.data()));
				this.setState({ comments: commentArray });
			})
			.catch(() => {});

		const menuCollections = ['Entrees', 'Desserts', 'Drinks', 'Extras'];
		const stateKeys      = ['entrees', 'desserts', 'drinks', 'extras'];
		menuCollections.forEach((col, i) => {
			db.collection('trucks').doc(id).collection(col).get()
				.then((snap) => {
					const items = [];
					snap.forEach(doc => items.push(doc.data()));
					this.setState({ [stateKeys[i]]: items });
				})
				.catch(() => {});
		});
	}

	renderMenuCards(items) {
		if (!items || items.length === 0) {
			return (
				<div className={style.emptyState}>
					<p>Nothing here yet</p>
				</div>
			);
		}
		return (
			<div className={style.wrapper}>
				{items.map((food, index) => (
					<Card className={style.item} key={index}>
						{food.image && (
							<Card.Img variant="top" className={style.cardImg} src={food.image} />
						)}
						<Card.Body className={style.cardBody}>
							<Card.Title className={style.cardTitle}>{food.name}</Card.Title>
							{food.price && (
								<span className={style.cardPrice}>${food.price}</span>
							)}
						</Card.Body>
					</Card>
				))}
			</div>
		);
	}

	render() {
		const { isLoading, error, truckInfo, truckHeroImgURL,
			facebook, instagram, twitter, youtube,
			entrees, desserts, drinks, extras, comments } = this.state;

		if (isLoading) {
			return (
				<div className={style.loadingContainer}>
					<div className={style.spinner} />
					<p>Loading…</p>
				</div>
			);
		}

		if (error) {
			return (
				<div className={style.loadingContainer}>
					<p className={style.errorText}>{error}</p>
				</div>
			);
		}

		const socialLinks = [
			{ account: facebook,  Icon: FaFacebookF },
			{ account: instagram, Icon: FaInstagram },
			{ account: twitter,   Icon: FaTwitter   },
			{ account: youtube,   Icon: FaYoutube   },
		];

		return (
			<div>
				{/* Hero */}
				<div
					className={style.hero}
					style={{ backgroundImage: truckHeroImgURL ? `url(${truckHeroImgURL})` : 'none' }}
				>
					<div className={style.heroOverlay} />

					<div className={style.socialBar}>
						{socialLinks.map(({ account, Icon }, i) =>
							account?.link ? (
								<a
									key={i}
									href={account.link}
									className={style.socialLink}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icon />
								</a>
							) : (
								<span key={i} className={`${style.socialLink} ${style.socialLinkDisabled}`}>
									<Icon />
								</span>
							)
						)}
					</div>

					{truckInfo?.title && (
						<div className={style.heroTitle}>
							<h1>{truckInfo.title}</h1>
						</div>
					)}
				</div>

				<Container className={style.pageContent}>
					{truckInfo?.description && (
						<p className={style.description}>{truckInfo.description}</p>
					)}

					{/* Menu tabs */}
					<Tabs fill bsPrefix={style.tabMain} defaultActiveKey="entrees" className={style.tabRow}>
						<Tab eventKey="entrees"  title="Entrees"  bsPrefix={style.tabOption}>{this.renderMenuCards(entrees)}</Tab>
						<Tab eventKey="desserts" title="Desserts" bsPrefix={style.tabOption}>{this.renderMenuCards(desserts)}</Tab>
						<Tab eventKey="drinks"   title="Drinks"   bsPrefix={style.tabOption}>{this.renderMenuCards(drinks)}</Tab>
						<Tab eventKey="extras"   title="Extras"   bsPrefix={style.tabOption}>{this.renderMenuCards(extras)}</Tab>
					</Tabs>

					{/* Reviews */}
					<div className={style.reviewSection}>
						<h5 className={style.reviewHeading}>Reviews</h5>
						{comments.length === 0 ? (
							<p className={style.noReviews}>No reviews yet</p>
						) : (
							comments.map((data, i) => (
								<div className={style.reviewCard} key={i}>
									<div className={style.reviewHeader}>
										<span className={style.reviewerName}>{data.userName}</span>
										<span className={style.reviewDate}>{data.dateofcomment}</span>
									</div>
									<p className={style.reviewText}>{data.comment}</p>
								</div>
							))
						)}
					</div>
				</Container>
			</div>
		);
	}
}

export default withRouter(TruckPage);
